import { DEFAULT_API_ENDPOINT, getStorage } from 'shared/lib/storage'

/**
 * Resolves the backend base URL: the dev-selected endpoint (from local storage,
 * set via the dev ApiEndpointSelect), falling back to the build-time default
 * (`http://localhost:8000` in dev).
 */
export function getApiBaseUrl(): string {
	return getStorage('dev')?.selectedApiEndpoint || DEFAULT_API_ENDPOINT
}
